
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/privacy-policy",
      function () {
        return require("private-next-pages/[insuranceType]/privacy-policy/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/privacy-policy"])
      });
    }
  